import { Component, Input } from "@angular/core";
import * as debug from 'debug';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'custom-tag',
  templateUrl: 'custom-tag.html',
})

export class CustomTagComponent {
  log = debug('app:CustomTagComponent');

  @Input() tag: string = '';
  @Input() overflow: boolean = false;
  @Input() selected: boolean = false;
  @Input() disabled: boolean = false;

  constructor(
    public tools: ToolsProvider,
  ) {}

  handleClick() {
    if (!this.disabled) {
      this.selected = !this.selected;
      if (this.selected) this.tools.emit('custom-tag-selected', this.tag);
      if (!this.selected) this.tools.emit('custom-tag-unselected');
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/custom-tag/custom-tag.ts